"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surveyApi = void 0;
const tslib_1 = require("tslib");
const hub_api_config_1 = require("../core/hub-api-config");
const error_utils_1 = require("../error-utils");
const URL_PREFIX = 'v3/survey';
const getAll = params => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    queryParams
  } = params;
  return hub_api_config_1.hubApiConfig.getInstance().get("/".concat(URL_PREFIX), {
    params: queryParams
  }).then(response => response.data).catch(error_utils_1.rethrowApiError);
});
const getResponseForAccount = params => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    pathParams
  } = params;
  return hub_api_config_1.hubApiConfig.getInstance().get("/".concat(URL_PREFIX, "/").concat(pathParams.surveyId, "/response/legacyAccount/").concat(pathParams.accountId)).then(response => response.data).catch(error_utils_1.rethrowApiError);
});
const createResponse = params => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    pathParams,
    data,
    queryParams
  } = params;
  return hub_api_config_1.hubApiConfig.getInstance().post("/".concat(URL_PREFIX, "/").concat(pathParams.surveyId, "/response"), data, {
    params: queryParams
  }).then(response => response.data).catch(error_utils_1.rethrowApiError);
});
const updateResponse = params => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
  const {
    pathParams,
    data
  } = params;
  return hub_api_config_1.hubApiConfig.getInstance().put("/".concat(URL_PREFIX, "/").concat(pathParams.surveyId, "/response/").concat(pathParams.responseId), data).then(response => response.data).catch(error_utils_1.rethrowApiError);
});
exports.surveyApi = {
  getAll,
  getResponseForAccount,
  createResponse,
  updateResponse
};